import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
  Tag,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { GenderData,typeData,attendanceTypeData } from "../../../data";
import { fetchPersonnelFolders } from "../../../features/folder/folderSlice";
import moment from "moment";
import { save } from "../../../features/save/saveSlice";

const { TextArea } = Input;

const AddEntriesModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { personnelFolders,fldLoading } = useSelector((state) => state.folder);
  const { user } = useSelector((state) => state.auth);
  const { saving } = useSelector((state) => state.save);
  const [data, setData] = useState({});

  const today = new Date();
  let dd = String(today.getDate()).padStart(2, 0);
  let mm = String(today.getMonth() + 1).padStart(2, 0);
  let yyyy = today.getFullYear() - 18;

  let minDate = `${yyyy}-${mm}-${dd}`;

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  function onMonthChange(value, formName) {
    setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }
  const onChangeOther = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    const res = await dispatch(
      save({
        attId:prodd?.attId ? prodd?.attId : null,
        attPpId: formData?.attPpId,
        attDate: formData?.attDate,
        attType:formData?.attType, 
        url: "hr/saveAttendance.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await handleCancel();
      await form.resetFields();  
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchPersonnelData() {
    dispatch(fetchPersonnelFolders());
  }

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title="Add attendance entries"
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="grid grid-cols-2 gap-x-5">
          <Form.Item
              className=""
              label={<span>Casual</span>}
              rules={[
                {
                  required: true,
                  message: "Please select casual",
                },
              ]}
            >
              <Select
                name="attPpId"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  personnelFolders?.length > 0 &&
                  personnelFolders?.map((item) => ({
                    value: item?.ppId,
                    label:
                      item?.ppPfno +
                      " - " +
                      item?.ppFullname +
                      " - " +
                      item?.coDeptname +
                      " - " +
                      item?.coSectionname,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "attPpId");
                }}
                value={formData?.ppFullname}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {
                  fetchPersonnelData();
                }}
                dropdownRender={(menu) => (
                  <>
                    {fldLoading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>
            <Form.Item
            rules={[
              {
                required: false,
                message: "Date field is required",
              },
            ]}
            label="Date"
          >
            <DatePicker
              name="attDate" 
              className="input"
              placeholder={
                formData?.attDate
                  ? moment(formData.attDate)?.format("DD-MM-YYYY")
                  : "Select Date"
              }
              value={formData?.attDate ? dayjs(formData.attDate) : null}
              format={"DD-MM-YYYY"}
              onChange={(value) => {
                onMonthChange(value, "attDate");
              }}
            />
          </Form.Item>
          <Form.Item
              className=""
              label={<span>Type</span>}
              rules={[
                {
                  required: true,
                  message: "Please select type",
                },
              ]}
            >
              <Select
                name="attType"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  typeData?.length > 0 &&
                  typeData?.map((item) => ({
                    value: item?.value,
                    label: item?.label  
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "attType");
                }}
                value={formData?.attType}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => { 
                }}
               
              />
            </Form.Item>
 
          </div>
          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddEntriesModal;
